import type { EmployeeModel } from "../../../../common/models/employeeModel";
import { httpClient } from "../../../../lib/http/axiosInstance";

export interface ExchangeTokenPayload {
  grantType: string;
  code: string;
  codeVerifier: string;
  clientId: string;
  redirectUri: string;
}

export interface TokenResponse {
  accessToken: string;
  refreshToken?: string;
  idToken?: string;
  tokenType: string;
  expiresIn: number;
}

export interface TokenResponseWrapper {
  data: TokenResponse;
}

export interface RolePermission {
  id: string;
  name: string;
  canView: boolean;
  canAdd: boolean;
  canEdit: boolean;
  canDelete: boolean;
}

export interface SSORole {
  id: string;
  name: string;
  permissions: RolePermission[];
}

export interface AuthenticatedUser extends EmployeeModel {
  role: SSORole | null;
}

export interface ProfileResponse {
  data: AuthenticatedUser;
}

export class AuthRemoteDataSource {
  async exchangeToken(payload: ExchangeTokenPayload): Promise<TokenResponseWrapper> {
    const response = await httpClient.post<TokenResponseWrapper>("/auth/exchange-token", payload);
    return response.data;
  }

  async getProfile(): Promise<ProfileResponse> {
    const response = await httpClient.get<ProfileResponse>("/auth/me");
    return response.data;
  }
}
